import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchAddSubcontractor = async (
  projectId,
  targetOrganizationChartItemId,
  subcontractorBusinessId,
  subcontractorBusinessName,
  subcontractorChartItemIdToMove,
  existingBusinessActionType
) => {
  const apiPath = `organization-charts/project/${projectId}/add-subcontractor`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      targetOrganizationChartItemId,
      subcontractorBusinessId,
      subcontractorBusinessName,
      subcontractorChartItemIdToMove,
      existingBusinessActionType,
    },
    activeEmployerInfo: {},
  });

  const response = await axios(signedRequest);

  return response.data;
};
